import { defineMessages } from 'react-intl';

export default defineMessages({

    lossCauseText: {
        id: 'twia.quoteandbind.ho.views.Please select cause of Loss',
        defaultMessage: 'Please select cause of Loss',
    },
    bothWindHail: {
        id: 'twia.quoteandbind.ho.views.Both',
        defaultMessage: 'Both',
    },
    bothWindandHail: {
        id: 'fnol.common.directives.loss-location.Both Wind & Hail',
        defaultMessage: 'Both Wind & Hail'
    },
    checkBoxMessage: {
        id: 'fnol.common.directives.loss-location.Damage must be indicated to atleast one of the locations.',
        defaultMessage: 'Damage must be indicated to at least one of the locations.'
    },
    additionalLossPageTitle: {
        id: 'fnol.common.directives.loss-details-page.Additional Loss Details',
        defaultMessage: 'Additional Loss Details'
    },

})